import {
  Bone,
  HeaderSkeleton,
  Line,
  SkeletonRegion,
  TableSkeleton,
} from '@ems/ui/patterns/skeleton-blocks'

export function MediaLibrarySkeleton() {
  return (
    <SkeletonRegion className="flex flex-col gap-6">
      <HeaderSkeleton title="w-20" description={null} actions={['h-8 w-24']} />
      <div className="flex flex-col gap-6">
        <div className="flex flex-wrap items-center gap-3 rounded-md border border-dashed p-4">
          <Bone className="h-9 w-32" />
          <Line width="w-64" />
        </div>
        <div className="flex flex-wrap items-center gap-3">
          <div className="flex min-w-0 flex-1 gap-2">
            <Bone className="h-9 w-full max-w-md" />
            <Bone className="h-9 w-20" />
          </div>
          <Bone className="h-8 w-52" />
        </div>
        <TableSkeleton
          columns={[
            { cell: 'thumb', header: null, shrink: true, hideOnCard: true },
            {
              cell: 'two-line',
              widths: ['w-48', 'w-20', 'w-56', 'w-16'],
              primary: true,
              truncate: true,
            },
            { cell: 'two-line', widths: ['w-16', 'w-20'], align: 'end' },
            { cell: 'muted', widths: ['w-24', 'w-28'] },
            { cell: 'button', widths: ['w-16', 'w-24'] },
            { cell: 'button', widths: ['w-[68px]'], header: null, align: 'end', shrink: true },
          ]}
        />
        <Bone className="h-9 w-28 self-center" />
      </div>
    </SkeletonRegion>
  )
}
